import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import NotFoundLogo from 'assets/icons/404.svg'
import Header from 'components/Layout/Header'
import { SearchBarProvider } from 'components/Layout/Header/SearchBar/SearchBarContext'
import i18nConfig from 'next-i18next.config'
import {
  Background,
  NoiseBackground,
  NotFoundCenter,
  NotFoundContainer,
  NotFoundLink,
  NotFoundSquare,
  NotFoundText,
  NotFoundTitle
} from 'styles/rootPages/404.style'
import { defaultFrontLocales } from 'utils/locale'

import '@algolia/autocomplete-theme-classic'

const Custom404 = () => {
  const { t } = useTranslation('common')

  const allCurrencies = ['EUR', 'CAD', 'CHF']
  return (
    <>
      <Background />
      <NoiseBackground blendMode />

      <NotFoundContainer>
        <SearchBarProvider>
          <Header allCurrencies={allCurrencies} rounded />
          <NotFoundCenter>
            <NotFoundSquare>
              <NotFoundLogo />
              <NotFoundTitle>{t('notFound.error')}</NotFoundTitle>
              <NotFoundText>
                {t('notFound.message')}{' '}
                <NotFoundLink href={'/'}>fr.milesrepublic.com</NotFoundLink>
              </NotFoundText>
            </NotFoundSquare>
          </NotFoundCenter>
        </SearchBarProvider>
      </NotFoundContainer>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(
        locale ?? 'fr',
        defaultFrontLocales,
        i18nConfig
      ))
    }
  }
}

export default Custom404
